import {
  AppstoreOutlined,
  CustomerServiceOutlined,
  CreditCardOutlined,
  DashboardOutlined,
  DollarOutlined,
  HistoryOutlined,
  RollbackOutlined,
  SettingOutlined,
  ShopOutlined,
  StarOutlined,
  StopOutlined,
  SwapOutlined,
  TagOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { STATUS_PILL_CLASSES } from "../theme/statusColors";

export enum PaymentMethodLimit {
  BOTH = "BOTH",
  PAY_ONLINE = "PAY_ONLINE",
  PAY_AT_SALON = "PAY_AT_SALON"
};

export enum OutletStatusEnum {
  WAIT_FOR_REVIEW = 1,
  REVIEWING = 2,
  REJECTED = 3,
  ACTIVE = 4
}

export enum ROLE {
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  USER = "USER",
  LEADER = "LEADER",
}

export const ROLE_OBJ = {
  SUPER_ADMIN: "Super admin",
  ADMIN: "Admin",
  USER: "User",
  LEADER: "Leader"
}

export const outletStatusEnumFromString: { [key: string]: OutletStatusEnum } = {
  'WAIT_FOR_REVIEW': OutletStatusEnum.WAIT_FOR_REVIEW,
  'REVIEWING': OutletStatusEnum.REVIEWING,
  'REJECTED': OutletStatusEnum.REJECTED,
  'ACTIVE': OutletStatusEnum.ACTIVE,
};

export const outletStatusStringMap: { [key in OutletStatusEnum]: string } = {
  [OutletStatusEnum.WAIT_FOR_REVIEW]: 'WAIT_FOR_REVIEW',
  [OutletStatusEnum.REVIEWING]: 'REVIEWING',
  [OutletStatusEnum.REJECTED]: 'REJECTED',
  [OutletStatusEnum.ACTIVE]: 'ACTIVE',
};

export const getOutletStatusEnumFromString = (statusString: string): OutletStatusEnum | undefined => {
  return outletStatusEnumFromString[statusString] as OutletStatusEnum;
};

export const getOutletStatusStringFromKey = (key: OutletStatusEnum): string => {
  return outletStatusStringMap[key];
}

export enum Component {
  home = "home",
  category = "category",
  categoryDetail = "categoryDetail",
  coupon = "coupon",
  dashboard = "dashboard",
  history_log = "history-log",
  help_support = "help-support",
  help_support_detail = "helpSupportDetail",
  outlet_change_requests = "outletChangeRequests",
  notifications = "notifications",
  outlet_change_request_detail = "outletChangeRequestDetail",
  map = "map",
  salon = "salon",
  addSalon = "addSalon",
  editSalon = "editSalon",
  editRegistrationSalon = "editRegistrationSalon",
  admin = "admin",
  setting = "setting",
  order = "order",
  orderDetail = "orderDetail",
  language = "language",
  package = "package",
  country = "country",
  countryDetail = "countryDetail",
  adminDetail = "adminDetail",
  userApp = "userApp",
  userAppDetail = "userAppDetail",
  appTranslation = "appTranslation",
  salonTranslation = "salonTranslation",
  systemConfig = "systemConfig",
  loyalty = "loyalty",
  aiChat = "aiChat",
  billingFeeConfig = "billingFeeConfig",
  paymentGatewayConfig = "paymentGatewayConfig",
  exchangeRateConfig = "exchangeRateConfig",
  cancellationPolicyConfig = "cancellationPolicyConfig",
  refundRequests = "refundRequests",
  systemConfigs = "systemConfigs",
  errorMessages = "errorMessages",
  cancelReasons = "cancelReasons",
  packageList = "packageList",
  packageCreate = "packageCreate",
  packageEdit = "packageEdit",
  packageMenuConfig = "packageMenuConfig",
  menuList = "menuList",
  menuCreate = "menuCreate",
  menuEdit = "menuEdit",
  menuReorder = "menuReorder",
  reviewModeration = "reviewModeration",
  roles = "roles",
}

export interface Menu {
  id?: string;
  path: string;
  icon?: React.ReactNode;
  name: string;
  routes?: Menu[];
}

export const MenuList: Menu[] = [
  {
    path: "/dashboard",
    name: "Dashboard",
    routes: [],
    icon: <DashboardOutlined />,
  },
  {
    path: "/admin",
    name: "Manager Admin",
    routes: [],
    icon: <UserOutlined />,
  },
  {
    path: "/app-users",
    name: "Manager User App",
    routes: [],
    icon: <UserOutlined />,
  },
  {
    path: "/salon",
    name: "Manager Salon",
    icon: <ShopOutlined />,
    routes: [],
  },
  {
    path: "/category",
    name: "Category",
    icon: <AppstoreOutlined />,
    routes: [],
  },
  // {
  //   path: "/map",
  //   name: "Map",
  //   icon: <FlagOutlined />,
  //   routes: [],
  // },
  {
    path: "/coupon",
    icon: <TagOutlined />,
    name: "Coupon",
    routes: [],
  },
  {
    path: "/help-support",
    icon: <CustomerServiceOutlined />,
    name: "Help-support",
    routes: [],
  },
  {
    path: "/outlet-change-requests",
    icon: <CustomerServiceOutlined />,
    name: "Change Requests",
    routes: [],
  },
  {
    path: "/history-log",
    icon: <HistoryOutlined />,
    name: "History-log",
    routes: [],
  },
  {
    icon: <UnorderedListOutlined />,
    path: "/orders",
    name: "Order",
    routes: [],
  },
  {
    icon: <StarOutlined />,
    path: "/review-moderation",
    name: "Review Moderation",
    routes: [],
  },
  {
    icon: <SettingOutlined />,
    path: "/setting",
    name: "Setting",
    routes: [
      {
        id: "5",
        path: "/setting/multi-lang",
        name: "Localization",
        routes: [
          {
            id: "1",
            path: "/setting/language",
            name: "Language",
            routes: [],
          },
          {
            id: "3",
            path: "/setting/country",
            name: "Country",
            routes: [],
          },
          {
            id: "5.1",
            path: "/setting/multi-lang/app",
            name: "App",
            routes: [],
          },
          {
            id: "5.2",
            path: "/setting/multi-lang/salon",
            name: "Salon",
            routes: [],
          },
          {
            id: "5.3",
            path: "/setting/system-config",
            name: "Common",
            routes: [],
          },
          {
            id: "5.4",
            path: "/setting/message-codes",
            name: "Error Code",
            routes: [],
          },
          {
            id: "5.5",
            path: "/setting/cancel-reasons",
            name: "Cancel reason",
            routes: [],
          },
        ],
      },
      {
        id: "8",
        path: "/settings/menus",
        name: "Menu Items",
        routes: [],
      },
      {
        id: "14",
        path: "/setting/config",
        name: "Config",
        routes: [
          {
            id: "2",
            path: "/settings/packages",
            name: "Package",
            routes: [],
          },
          {
            id: "11",
            path: "/setting/billing-fees",
            name: "Billing Fee",
            routes: [],
            icon: <DollarOutlined />,
          },
          {
            id: "12",
            path: "/setting/payment-gateways",
            name: "Payment Gateway",
            routes: [],
            icon: <CreditCardOutlined />,
          },
          {
            id: "19",
            path: "/setting/exchange-rates",
            name: "Exchange Rate",
            routes: [],
            icon: <SwapOutlined />,
          },
          {
            id: "17",
            path: "/setting/cancellation-policies",
            name: "Cancellation Policy",
            routes: [],
            icon: <StopOutlined />,
          },
          {
            id: "18",
            path: "/setting/refund-requests",
            name: "Refund Requests",
            routes: [],
            icon: <RollbackOutlined />,
          },
          {
            id: "15",
            path: "/setting/system-configs",
            name: "System",
            routes: [],
            icon: <SettingOutlined />,
          },
        ],
      },
      {
        id: "16",
        path: "/setting/features",
        name: "Features",
        routes: [
          {
            id: "9",
            path: "/setting/loyalty",
            name: "Loyalty Points",
            routes: [],
          },
          {
            id: "10",
            path: "/setting/ai-chat",
            name: "AI Chat",
            routes: [],
          },
        ],
      },
      {
        id: "13",
        path: "/setting/roles",
        name: "Roles & Permissions",
        routes: [],
      },
    ],
  },
];

export const currency_list = [
  { name: "Afghan Afghani", value: "AFA" },
  { name: "Albanian Lek", value: "ALL" },
  { name: "Algerian Dinar", value: "DZD" },
  { name: "Angolan Kwanza", value: "AOA" },
  { name: "Argentine Peso", value: "ARS" },
  { name: "Armenian Dram", value: "AMD" },
  { name: "Aruban Florin", value: "AWG" },
  { name: "Australian Dollar", value: "AUD" },
  { name: "Azerbaijani Manat", value: "AZN" },
  { name: "Bahamian Dollar", value: "BSD" },
  { name: "Bahraini Dinar", value: "BHD" },
  { name: "Bangladeshi Taka", value: "BDT" },
  { name: "Barbadian Dollar", value: "BBD" },
  { name: "Belarusian Ruble", value: "BYR" },
  { name: "Belgian Franc", value: "BEF" },
  { name: "Belize Dollar", value: "BZD" },
  { name: "Bermudan Dollar", value: "BMD" },
  { name: "Bhutanese Ngultrum", value: "BTN" },
  { name: "Bitcoin", value: "BTC" },
  { name: "Bolivian Boliviano", value: "BOB" },
  { name: "Bosnia-Herzegovina Convertible Mark", value: "BAM" },
  { name: "Botswanan Pula", value: "BWP" },
  { name: "Brazilian Real", value: "BRL" },
  { name: "British Pound Sterling", value: "GBP" },
  { name: "Brunei Dollar", value: "BND" },
  { name: "Bulgarian Lev", value: "BGN" },
  { name: "Burundian Franc", value: "BIF" },
  { name: "Cambodian Riel", value: "KHR" },
  { name: "Canadian Dollar", value: "CAD" },
  { name: "Cape Verdean Escudo", value: "CVE" },
  { name: "Cayman Islands Dollar", value: "KYD" },
  { name: "CFA Franc BCEAO", value: "XOF" },
  { name: "CFA Franc BEAC", value: "XAF" },
  { name: "CFP Franc", value: "XPF" },
  { name: "Chilean Peso", value: "CLP" },
  { name: "Chilean Unit of Account", value: "CLF" },
  { name: "Chinese Yuan", value: "CNY" },
  { name: "Colombian Peso", value: "COP" },
  { name: "Comorian Franc", value: "KMF" },
  { name: "Congolese Franc", value: "CDF" },
  { name: "Costa Rican Colón", value: "CRC" },
  { name: "Croatian Kuna", value: "HRK" },
  { name: "Cuban Convertible Peso", value: "CUC" },
  { name: "Czech Republic Koruna", value: "CZK" },
  { name: "Danish Krone", value: "DKK" },
  { name: "Djiboutian Franc", value: "DJF" },
  { name: "Dominican Peso", value: "DOP" },
  { name: "East Caribbean Dollar", value: "XCD" },
  { name: "Egyptian Pound", value: "EGP" },
  { name: "Eritrean Nakfa", value: "ERN" },
  { name: "Estonian Kroon", value: "EEK" },
  { name: "Ethiopian Birr", value: "ETB" },
  { name: "Euro", value: "EUR" },
  { name: "Falkland Islands Pound", value: "FKP" },
  { name: "Fijian Dollar", value: "FJD" },
  { name: "Gambian Dalasi", value: "GMD" },
  { name: "Georgian Lari", value: "GEL" },
  { name: "German Mark", value: "DEM" },
  { name: "Ghanaian Cedi", value: "GHS" },
  { name: "Gibraltar Pound", value: "GIP" },
  { name: "Greek Drachma", value: "GRD" },
  { name: "Guatemalan Quetzal", value: "GTQ" },
  { name: "Guinean Franc", value: "GNF" },
  { name: "Guyanaese Dollar", value: "GYD" },
  { name: "Haitian Gourde", value: "HTG" },
  { name: "Honduran Lempira", value: "HNL" },
  { name: "Hong Kong Dollar", value: "HKD" },
  { name: "Hungarian Forint", value: "HUF" },
  { name: "Icelandic Króna", value: "ISK" },
  { name: "Indian Rupee", value: "INR" },
  { name: "Indonesian Rupiah", value: "IDR" },
  { name: "Iranian Rial", value: "IRR" },
  { name: "Iraqi Dinar", value: "IQD" },
  { name: "Israeli New Sheqel", value: "ILS" },
  { name: "Italian Lira", value: "ITL" },
  { name: "Jamaican Dollar", value: "JMD" },
  { name: "Japanese Yen", value: "JPY" },
  { name: "Jordanian Dinar", value: "JOD" },
  { name: "Kazakhstani Tenge", value: "KZT" },
  { name: "Kenyan Shilling", value: "KES" },
  { name: "Kuwaiti Dinar", value: "KWD" },
  { name: "Kyrgystani Som", value: "KGS" },
  { name: "Laotian Kip", value: "LAK" },
  { name: "Latvian Lats", value: "LVL" },
  { name: "Lebanese Pound", value: "LBP" },
  { name: "Lesotho Loti", value: "LSL" },
  { name: "Liberian Dollar", value: "LRD" },
  { name: "Libyan Dinar", value: "LYD" },
  { name: "Litecoin", value: "LTC" },
  { name: "Lithuanian Litas", value: "LTL" },
  { name: "Macanese Pataca", value: "MOP" },
  { name: "Macedonian Denar", value: "MKD" },
  { name: "Malagasy Ariary", value: "MGA" },
  { name: "Malawian Kwacha", value: "MWK" },
  { name: "Malaysian Ringgit", value: "MYR" },
  { name: "Maldivian Rufiyaa", value: "MVR" },
  { name: "Mauritanian Ouguiya", value: "MRO" },
  { name: "Mauritian Rupee", value: "MUR" },
  { name: "Mexican Peso", value: "MXN" },
  { name: "Moldovan Leu", value: "MDL" },
  { name: "Mongolian Tugrik", value: "MNT" },
  { name: "Moroccan Dirham", value: "MAD" },
  { name: "Mozambican Metical", value: "MZM" },
  { name: "Myanmar Kyat", value: "MMK" },
  { name: "Namibian Dollar", value: "NAD" },
  { name: "Nepalese Rupee", value: "NPR" },
  { name: "Netherlands Antillean Guilder", value: "ANG" },
  { name: "New Taiwan Dollar", value: "TWD" },
  { name: "New Zealand Dollar", value: "NZD" },
  { name: "Nicaraguan Córdoba", value: "NIO" },
  { name: "Nigerian Naira", value: "NGN" },
  { name: "North Korean Won", value: "KPW" },
  { name: "Norwegian Krone", value: "NOK" },
  { name: "Omani Rial", value: "OMR" },
  { name: "Pakistani Rupee", value: "PKR" },
  { name: "Panamanian Balboa", value: "PAB" },
  { name: "Papua New Guinean Kina", value: "PGK" },
  { name: "Paraguayan Guarani", value: "PYG" },
  { name: "Peruvian Nuevo Sol", value: "PEN" },
  { name: "Philippine Peso", value: "PHP" },
  { name: "Polish Zloty", value: "PLN" },
  { name: "Qatari Rial", value: "QAR" },
  { name: "Romanian Leu", value: "RON" },
  { name: "Russian Ruble", value: "RUB" },
  { name: "Rwandan Franc", value: "RWF" },
  { name: "Salvadoran Colón", value: "SVC" },
  { name: "Samoan Tala", value: "WST" },
  { name: "São Tomé and Príncipe Dobra", value: "STD" },
  { name: "Saudi Riyal", value: "SAR" },
  { name: "Serbian Dinar", value: "RSD" },
  { name: "Seychellois Rupee", value: "SCR" },
  { name: "Sierra Leonean Leone", value: "SLL" },
  { name: "Singapore Dollar", value: "SGD" },
  { name: "Slovak Koruna", value: "SKK" },
  { name: "Solomon Islands Dollar", value: "SBD" },
  { name: "Somali Shilling", value: "SOS" },
  { name: "South African Rand", value: "ZAR" },
  { name: "South Korean Won", value: "KRW" },
  { name: "South Sudanese Pound", value: "SSP" },
  { name: "Special Drawing Rights", value: "XDR" },
  { name: "Sri Lankan Rupee", value: "LKR" },
  { name: "St. Helena Pound", value: "SHP" },
  { name: "Sudanese Pound", value: "SDG" },
  { name: "Surinamese Dollar", value: "SRD" },
  { name: "Swazi Lilangeni", value: "SZL" },
  { name: "Swedish Krona", value: "SEK" },
  { name: "Swiss Franc", value: "CHF" },
  { name: "Syrian Pound", value: "SYP" },
  { name: "Tajikistani Somoni", value: "TJS" },
  { name: "Tanzanian Shilling", value: "TZS" },
  { name: "Thai Baht", value: "THB" },
  { name: "Tongan Pa'anga", value: "TOP" },
  { name: "Trinidad & Tobago Dollar", value: "TTD" },
  { name: "Tunisian Dinar", value: "TND" },
  { name: "Turkish Lira", value: "TRY" },
  { name: "Turkmenistani Manat", value: "TMT" },
  { name: "Ugandan Shilling", value: "UGX" },
  { name: "Ukrainian Hryvnia", value: "UAH" },
  { name: "United Arab Emirates Dirham", value: "AED" },
  { name: "Uruguayan Peso", value: "UYU" },
  { name: "US Dollar", value: "USD" },
  { name: "Uzbekistan Som", value: "UZS" },
  { name: "Vanuatu Vatu", value: "VUV" },
  { name: "Venezuelan BolÃvar", value: "VEF" },
  { name: "Vietnamese Dong", value: "VND" },
  { name: "Yemeni Rial", value: "YER" },
  { name: "Zambian Kwacha", value: "ZMK" },
  { name: "Zimbabwean dollar", value: "ZWL" },
];

export interface OptionFilter {
  value: string;
  label: string;
}

export interface SearchForm {
  isUser?: boolean;
  page: number;
  size: number;
  search?: string;
  filter?: string;
  direction?: string; 
  sortField?: string; 
  countryId?: string; 
}

export interface ErrorMessageResponse {
  code: string;
  message: string;
}

export const CHART_TYPE = ["line", "area","bar","pie","donut","radialBar","scatter","bubble","heatmap","candlestick","boxPlot","radar","polarArea","rangeBar","rangeArea","treemap"];
export const CHART_COLOR = ["#8A3B2A", "#2E8A2A", "#2A8A7D", "#2A498A", "#602A8A", "#862A8A", "#F20896", "#F2084B", "#F20808"];
export const CHART_TYPE_ARR = CHART_TYPE.map((type) => ({ key: type, value: type }));
export const CHART_COLOR_ARR = CHART_COLOR.map((color) => ({key: color, value: color}))

export interface DropdownObject {
  value: any;
  key: any;
}

export interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: 'right' | 'center' | 'left';
  width?: number
  format?: (value: any, row?: any) => any;
  sortable?: boolean;
}

export interface User {
  id: number;
  full_name: string | null;
  email: string;
  phone_number: string | null;
  avatar: string | null;
  role: {
    description: string;
    name: string;
  };
  role_id?: number | null;
  role_code?: string | null;
  role_name?: string | null;
  locations: any[]; // Adjust type based on the structure of location objects if known
  can_edit: boolean;
  outlets: any | null; // Adjust type if the structure of outlets is known
  created_date: string; // Use `Date` if parsed as a JavaScript Date object
}
export const HTTP_METHOD_COLOR = {
  GET: {
    color: 'bg-blue-400'
  },
  POST: {
    color: 'bg-green-400'
  },
  DELETE: {
    color: 'bg-red-400'
  },
  PATCH: {
    color: 'bg-orange-400'
  }
}

export const HTTP_STATUS_CODE_COLOR = {
  200: {
    color: STATUS_PILL_CLASSES.SUCCESS
  },
  500: {
    color: STATUS_PILL_CLASSES.DANGER
  },
}

export enum HELP_SUPPORT_STATUS {
  WAITING="WAITING",
  SUPPORTING="SUPPORTING",
  CLOSED="CLOSED"
}
